// Create redux store with history

import configureStore from '../configureStore';
import history from 'utils/common/history';

const initialState = {};
const storeApp = configureStore(initialState, history);
export default storeApp;
